$(function(){


  $('#select_inquiry').change(function(){
    var val = $(this).val();
    if (val == "他店での注文について") {
      $('.other_shop').show();
      $('.other_shop input').attr('required','true');
    }else{
      $('.other_shop').hide();
      $('.other_shop input').removeAttr('required');
    }
    if (val == "当店での注文について") {
      $('.this_shop').show();
      $('.this_shop input').attr('required','true');
    }else{
      $('.this_shop').hide();
      $('.this_shop input').removeAttr('required');
    }
  });


});



$(function(){
  $('.ip_more_btn').click(function(){
    var blockHeight = $('.ip_image_container ul').height();
    $('.ip_image_container').css('height',blockHeight + 'px');
    $('.ip_more_btn').addClass('open');
  });
});

$(window).on('load resize',function(){
  var imageHeight = $('.ip_image_container li').height();
  var containerWidth = $('.ip_image_container').width();
  var containerHeight = (imageHeight * 2) + (containerWidth * 0.02);
  $('.ip_image_container').css('height',containerHeight + 'px');
});


